import { render, staticRenderFns } from "./storesToConnect.vue?vue&type=template&id=4f481f3c"
import script from "./storesToConnect.vue?vue&type=script&lang=js"
export * from "./storesToConnect.vue?vue&type=script&lang=js"
import style0 from "./storesToConnect.vue?vue&type=style&index=0&id=4f481f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports